import { Outlet, createFileRoute } from '@tanstack/react-router';
import { DarkModeToggle } from '@/components/shared/dark-mode-toggle';
import { OptimizedPicture, SmartBanner } from '@/components/common';

export const Route = createFileRoute('/(cleaner)/_auth-layout')({
  component: RouteComponent,
  head: () => ({
    links: [
      {
        rel: 'preload',
        as: 'image',
        href: '/images/logo-200.webp',
        type: 'image/webp',
      },
      {
        rel: 'preload',
        as: 'image',
        href: '/images/sign_img_cleaner.webp',
        type: 'image/webp',
        media: '(min-width: 1024px)',
      },
    ],
  }),
});

function RouteComponent() {
  return (
    <div className="grid min-h-svh lg:grid-cols-2">
      <SmartBanner role="cleaner" />
      <div className="bg-muted relative hidden lg:block">
        <OptimizedPicture
          webpSrc="/images/sign_img_cleaner.webp"
          fallbackSrc="/images/sign_img_cleaner.jpg"
          alt="Cleaner signing in to Itria Home"
          fetchPriority="low"
          width={937}
          height={900}
          className="absolute inset-0 h-full w-full object-cover"
        />
      </div>
      <div className="flex flex-col gap-4 p-6 md:p-10">
        <div className="flex justify-end">
          <DarkModeToggle variant="icon" />
        </div>
        <div className="flex flex-1 items-center justify-center">
          <div className="w-full max-w-sm">
            <a
              href="#"
              className="flex items-center justify-center gap-2 font-medium mb-10"
            >
              <OptimizedPicture
                webpSrc="/images/logo-200.webp"
                fallbackSrc="/images/logo-200.png"
                alt="Itria Home logo"
                fetchPriority="high"
                width={200}
                height={140}
                className="h-20 w-auto mb-2"
              />
            </a>
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
}
